import React from 'react';

export interface IRemoveSlideButtonProps {
  dataHint: string;
  onClick(): void;
}

export const RemoveSlideButton = ({ dataHint, onClick }: IRemoveSlideButtonProps) => (
  <a role="button" data-test="remove-slide-button" onClick={onClick}>
    <span
      className="icon-trash-1"
      data-hint={dataHint}
      data-hint-position="bottom"
      data-hint-align="center"
      contentEditable={false}
      tabIndex={0}
    />
  </a>
);
